export default "__VITE_ASSET__rOVcuLOv__"